import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function SeaStateGuide() {
  return <LocalizedWeatherGuidePage guideKey="seaState" />;
}